<template>
  <div @click="$emit('click', $event)"
       v-show="show_el">
    <div v-html="get_match_val" key="MatchText"></div>
  </div>
</template>

<script>
export default {
  name: "MatchText",
  props: {
    name: {
      type: String,
      default: ''
    },
    match_val: {
      type: String,
      default: ''
    },
    prop_id: {
      type: [String, Number],
    },
    hidden_match: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    show_el() {
      return (!this.hidden_match || !this.match_val)
        ? true
        : this.name.toLowerCase().includes(this.match_val.toLowerCase())
    },
    get_match_val() {
      if (!this.match_val) return this.name
      // ignore case (optional) and match all
      let regexp = new RegExp(`(${this.match_val})`, 'ig');
      let match = this.name.match(regexp) || ''
      match = match.length ? match[0] : ''
      return this.name.replaceAll(match, `<b>${match}</b>`)
    }
  }
}
</script>
